module.exports = __webpack_public_path__ + "img/blog-detail-placeholder.0d82eedc.png";